import service from '@/lib/request'

const baseURL = process.env.REACT_APP_BASE_URL || '/api'

// 权限相关放这里
const MAPI = {
  // 获取地区数据
  getAddress: () => service.get(`${baseURL}/resource/getAddress`),
  saveOrUpdate: (params) => service.post(`${baseURL}/carrier/carrierContactInfoFacade/saveOrUpdate`, [params]),
  // 线路订阅
  routeSaveOrUpdate: (params) => service.post(`${baseURL}/carrier/lineSubscribeFacade/saveOrUpdate`, [params]),
}

export default MAPI
